/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import logoIcon from "../images/logoOnly.png";

const UbicacionSection = () => {
  return (
    <section
      id="Ubicacion"
      className="w-full py-12 md:py-24 lg:py-32 bg-background text-white"
    >
      {/* Versión Escritorio - Se oculta en móvil */}
      <div className="hidden md:block container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-start gap-16">
          {/* Columna Izquierda */}
          <div className="w-full md:w-1/2">
            <h2 className="text-2xl font-bold mb-8">Ubicación:</h2>
            <p className="text-xl mb-8">
              RUTA N° 9 KM 747 - PARQ INDUSTRIAL, COLONIA CAROYA
            </p>
            <iframe
              title="Ubicación de Logística Huemul"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2761.1642232129537!2d-64.11654752536413!3d-31.025239089215186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x943216551d2755eb%3A0x5016258350cb2868!2sLog%C3%ADstica%20Huemul!5e0!3m2!1ses!2sar!4v1694096784674!5m2!1ses!2sar"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Columna Derecha */}
          <div className="w-full md:w-1/2 flex flex-col items-end text-right">
            <h2 className="text-2xl font-bold mb-8">CONTACTO:</h2>
            
            <div className="mb-8">
              <h3 className="text-2xl font-bold mb-4">Teléfonos:</h3>
              <p className="mb-2">Jorge Echegaray: +54 3525 44-7655</p>
              <p className="mb-2">Tristán Echegaray: +54 351 732-2764</p>
              <p className="mb-2">Guadalupe Sueldo: +54 3525 47-9014</p>
              <p className="mb-2">
                Administración Francina - Irina: +54 3525 45-4436
              </p>
            </div>

            <div className="mb-8">
              <h3 className="text-2xl font-bold mb-4">Correo electrónico:</h3>
              <p className="mb-2">adm.logisticahuemul@gmail.com</p>
            </div>

            <div className="mb-12">
              <h3 className="text-2xl font-bold mb-4">
                Horario de Atención oficina
              </h3>
              <p>Lunes a viernes, 8:00 a. m. - 5:00 p. m.</p>
            </div>

            <div className="flex items-center gap-2">
              <img
                src={logoIcon}
                alt="Logo Huemul"
                className="object-cover w-24 h-24"
              />
              <div className="h-24 flex flex-col justify-end">
                <h1 className="text-4xl font-semibold whitespace-nowrap text-white">
                  LOGÍSTICA HUEMUL
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Versión Móvil - Se oculta en escritorio */}
      <div className="md:hidden container mx-auto px-4">
        <h2 className="text-2xl font-bold mb-8 text-center">CONTACTO</h2>
        
        <div className="mb-12">
          <h3 className="text-xl font-bold mb-4 text-center">Ubicación:</h3>
          <p className="text-lg mb-4 text-center">
            RUTA N° 9 KM 747 - PARQ INDUSTRIAL, COLONIA CAROYA
          </p>
          <iframe
            title="Ubicación de Logística Huemul"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2761.1642232129537!2d-64.11654752536413!3d-31.025239089215186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x943216551d2755eb%3A0x5016258350cb2868!2sLog%C3%ADstica%20Huemul!5e0!3m2!1ses!2sar!4v1694096784674!5m2!1ses!2sar"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div className="space-y-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-center">Teléfonos:</h3>
            <div className="space-y-2 text-center">
              <p>Jorge Echegaray: +54 3525 44-7655</p>
              <p>Tristán Echegaray: +54 351 732-2764</p>
              <p>Guadalupe Sueldo: +54 3525 47-9014</p>
              <p>Administración Francina - Irina: +54 3525 45-4436</p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 text-center">Correo electrónico:</h3>
            <p className="text-center">adm.logisticahuemul@gmail.com</p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 text-center">Horario de Atención oficina</h3>
            <p className="text-center">Lunes a viernes, 8:00 a. m. - 5:00 p. m.</p>
          </div>
        </div>

        <div className="flex justify-center items-center mt-12">
          <img
            src={logoIcon}
            alt="Logo Huemul"
            className="object-cover w-16 h-16"
          />
          <div className="h-16 flex flex-col justify-end">
            <h1 className="text-2xl font-semibold whitespace-nowrap text-white">
              LOGÍSTICA HUEMUL
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UbicacionSection;
